import styled from "styled-components";
import { media } from "../../../../utils";

export const ContentComunicadoContent = styled.div({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  [media.md()]: {
    display: "block",
  },
});

const ContentComunicado = styled.div`
  display: flex;

  img {
    margin: 0 20px;
  }
  ${media.md()} {
    display: block;

    img {
      display: none;
    }
  }
`;

export default ContentComunicado;
